import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Editor, EditorInitEvent, EditorSelectionChangeEvent, EditorTextChangeEvent } from 'primeng/editor';
import {
  CreateStringValueAccessorProvider,
  CreateStringValueValidationProvider,
  StringValueAccessor,
} from '../../value-accessors/string-value-accessor';
import { WysiwygBase64Sanitizer } from '../../../util/wysiwyg-base64-sanitizer';
import { QuillUtils } from '../../../util/quill.utils';

@Component({
  selector: 'wl-simple-html-editor',
  templateUrl: './simple-html-editor.component.html',
  providers: [
    CreateStringValueAccessorProvider(SimpleHtmlEditorComponent),
    CreateStringValueValidationProvider(SimpleHtmlEditorComponent),
  ],
  standalone: false
})
export class SimpleHtmlEditorComponent extends StringValueAccessor implements AfterViewInit {
  @ViewChild('primeEditor', { static: false }) private primeEditor!: Editor;

  @Input() public required: boolean = false;

  @Input() public style: object | null = null;
  @Input() public styleClass: string | null = null;
  @Input() public placeholder: string | null = null;
  @Input() public formats: string[] | null = null;
  @Input() public modules: object | null = null;
  @Input() public bounds: string | HTMLElement | null = null;
  @Input() public scrollingContainer: string | HTMLElement | null = null;
  @Input() public debug: string | null = null;
  @Input() public readonly: boolean = false;

  @Input() public blockEmbeddedImages: boolean = true;

  @Output() public onTextChange: EventEmitter<EditorTextChangeEvent> = new EventEmitter<EditorTextChangeEvent>();
  @Output() public onInit: EventEmitter<EditorInitEvent> = new EventEmitter<EditorInitEvent>();
  @Output() public onSelectionChange: EventEmitter<EditorSelectionChangeEvent> = new EventEmitter<EditorSelectionChangeEvent>();

  private quillInstance: any;
  public constructor() {
    super();
  }

  ngAfterViewInit(): void {
    if (this.blockEmbeddedImages) {
      setTimeout(() => {
        if (typeof this.value === 'string') {
          const cleaned = WysiwygBase64Sanitizer.sanitizeInitialValue(this.value, true);
          if (cleaned !== this.value) {
            this.value = cleaned;
          }
        }
      }, 0);
    }
  }

  public isValid = (): boolean => {
    return !this.required || (this.value != null && this.value !== '');
  };

  public onEditorInitHandler(event: EditorInitEvent): void {
    this.quillInstance = event.editor;
    QuillUtils.attachImageBlocking(
      this.quillInstance,
      this.blockEmbeddedImages,
      (sanitizedValue: string) => {
        if (sanitizedValue !== this.value) {
          this.value = sanitizedValue;
        }
      }
    );
    this.onInit.emit(event);
  }

  public onTextChangeHandler(event: EditorTextChangeEvent): void {
    this.value = event.htmlValue || '';
    this.onTextChange.emit(event);
  }

  public onSelectionChangeHandler(event: EditorSelectionChangeEvent): void {
    this.onSelectionChange.emit(event);
  }
}
